import dayjs from 'dayjs';

const separateFileTableData = ({ inputData }) => {
  const tempInputData = { ...inputData };

  /** Separate file-table data */
  tempInputData?.doc?.shift();
  let docData = tempInputData?.doc;
  docData = docData?.map(doc => {
    doc.exp_date = dayjs(doc?.exp_date)?.isValid()
      ? dayjs(doc?.exp_date)?.format('YYYY-MM-DD')
      : '';

    // Delete unnecessary document properties
    delete doc?.updated_by;
    delete doc?.updated_date;
    delete doc?.updated_time;
    return doc;
  });

  /** Apply file-table data */
  const separatedData = {
    ...tempInputData,
  };

  return separatedData;
};

export default separateFileTableData;
